import { MixpanelSublocation } from "@sg-protect/shell";

export function getReportSublocation(searchParams: URLSearchParams) {
    switch (searchParams.get("source")) {
        case "ai":
            return MixpanelSublocation.AiGenerated;
        case "template":
            return MixpanelSublocation.Template;
        case "user":
            return MixpanelSublocation.Manual;
        default:
            return undefined;
    }
}
